import React, { useState, useEffect } from "react";
import { Select, Button, Typography, Spin, Card, Col, Row } from "antd";
import "./RecordingAll.less";
import { useGetRecordingsQuery } from "../../../redux/services/class";
import { useSelector } from "react-redux";
import { EmptyCard } from "../../../component";
import { useParams } from "react-router-dom";
import { useGetStudentBatchesQuery } from "../../../redux/services/batches";

const { Title, Text } = Typography;

const RecordingAll = () => {
  const { student_id } = useSelector((state) => state.auth);
  const { coaching_id } = useParams();
  const [filters, setFilters] = useState({
    coaching: "",
    course: "",
    subject: "",
  });
  const [coachingOptions, setCoachingOptions] = useState([]);
  const { data: recordings, isLoading: loading } = useGetRecordingsQuery({
    student_id: student_id,
    coaching_id: coaching_id,
  });

  const {
    data: batches,
    error,
    isLoading,
  } = useGetStudentBatchesQuery(student_id);

  useEffect(() => {
    if (batches?.data) {
      const uniqueCoachings = [
        ...new Set(batches.data.map((batch) => batch.coaching_name)),
      ];
      setCoachingOptions(
        uniqueCoachings.map((coaching) => ({
          value: coaching,
          label: coaching,
        }))
      );
    }
  }, [batches]);

  const handleFilterChange = (value, key) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleApplyFilters = () => {
    // Refetch the data when filters are applied
    // The query will automatically refetch because the `filters` state has changed
  };

  const RecordingsCard = ({
    lectureName,
    teacherName = "Vaibhav Lehra",
    date,
    time,
  }) => {
    return (
      <Card className='assignment-card'>
        <Row gutter={[16, 16]} className='info-row'>
          <Col span={12}>
            <div className='info-label'>Teacher Name</div>
            <div className='info-value'>{teacherName}</div>
          </Col>
          <Col span={12}>
            <div className='info-label'>Lecture Name</div>
            <div className='info-value'>{lectureName}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className='info-row'>
          <Col span={12}>
            <div className='info-label'>Due Date</div>
            <div className='info-value'>
              {date} | {time}
            </div>
          </Col>
          <Col span={12}>
            <Button
              type='primary'
              className='view-button'
              onClick={() => window.open(recordings.class_url, "_blank")}
            >
              View
            </Button>
          </Col>
        </Row>
      </Card>
    );
  };

  return (
    <div className='upcoming-class-container'>
      <div className='filters'>
        <Select
          placeholder='Coaching'
          onChange={(value) => handleFilterChange(value, "coaching")}
          style={{ width: 120 }}
          options={coachingOptions}
        />
        <Select
          placeholder='Course'
          onChange={(value) => handleFilterChange(value, "course")}
          style={{ width: 120 }}
          options={[
            {
              value: "course1",
              label: "Course 1",
            },
            {
              value: "course2",
              label: "Course 2",
            },
          ]}
        ></Select>
        <Select
          placeholder='Subject'
          onChange={(value) => handleFilterChange(value, "subject")}
          style={{ width: 120 }}
          options={[
            {
              value: "english",
              label: "English",
            },
            {
              value: "maths",
              label: "Maths",
            },
            {
              value: "physics",
              label: "Physics",
            },
            {
              value: "chemistry",
              label: "Chemistry",
            },
          ]}
        ></Select>
        <Button type='primary' onClick={handleApplyFilters}>
          Apply
        </Button>
      </div>
      <div className='upcoming-classes'>
        <Title className='title'>Recordings</Title>
        {loading ? (
          <Spin className='section-spinner' />
        ) : recordings?.data?.length > 0 ? (
          recordings?.data?.map((lecture) => (
            <RecordingsCard
              key={lecture.lecture_id}
              lectureName={lecture.lecture_name}
              teacherName={lecture.teacher_name}
              date={lecture.date}
              time={lecture.time}
              class_url={lecture.class_url}
            />
          ))
        ) : (
          <EmptyCard text={`No Upcoming classes`} />
        )}
      </div>
    </div>
  );
};

export default RecordingAll;
